var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import "../../Styling.js";
import { Stack } from "@fluentui/react/lib/Stack";
import { Label as Label$1 } from "@fluentui/react/lib/Label";
import "../Icon/index.js";
import { getTheme, mergeStyles } from "@fluentui/style-utilities";
import { Icon } from "../Icon/Icon.js";
class Label extends React.PureComponent {
  render() {
    const _a = this.props, {
      htmlFor,
      onRenderIcon = this._onRenderIcon,
      iconProps,
      containerProps,
      id,
      theme = getTheme(),
      text,
      children,
      className
    } = _a, rest = __objRest(_a, [
      "htmlFor",
      "onRenderIcon",
      "iconProps",
      "containerProps",
      "id",
      "theme",
      "text",
      "children",
      "className"
    ]);
    const defaultLabelStyles = {
      root: {
        fontWeight: 500,
        color: theme.semanticColors.bodyText,
        selectors: {
          "::after": {
            paddingRight: 0
          }
        }
      }
    };
    const defaultText = !!children ? children : text;
    return /* @__PURE__ */ jsxs(Stack, __spreadProps(__spreadValues({ horizontal: true, verticalAlign: "center" }, containerProps), { children: [
      /* @__PURE__ */ jsx(
        Label$1,
        __spreadProps(__spreadValues({
          htmlFor,
          id,
          styles: defaultLabelStyles
        }, rest), {
          className: mergeStyles("ms-fontWeight-semibold", className),
          children: defaultText
        })
      ),
      onRenderIcon(this.props)
    ] }));
  }
  _onRenderIcon(props) {
    const { iconProps, children } = props;
    const defaultAriaLabel = typeof children == "string" ? `${children} Info` : "Info";
    if (!iconProps)
      return null;
    const _a = iconProps, { calloutProps, ariaLabel, iconName = "Info" } = _a, rest = __objRest(_a, ["calloutProps", "ariaLabel", "iconName"]);
    if (!calloutProps)
      return null;
    return /* @__PURE__ */ jsx(Icon, __spreadValues({ ariaLabel: defaultAriaLabel, iconName, calloutProps }, rest));
  }
}
export {
  Label
};
//# sourceMappingURL=Label.js.map
